import * as React from 'react';
import { useTrashablePromise } from '../../../hooks';
import { apiRawFetch } from '../../../APIClient';
import { VirtualSensor } from '../../../types';

/**
 * @param enabled: whether the fetch should be executed in an immediate effect
 */
export const useFetchVirtualSensors = (enabled = true) => {
  const [vSensors, setVSensors] = React.useState<VirtualSensor>({});
  const [isLoading, setIsLoading] = React.useState(false);
  const [error, setError] = React.useState<any>(null);

  const { registerPromise } = useTrashablePromise();

  const getVirtualLogCollectorList = React.useCallback(async () => {
    setError(null);
    setIsLoading(true);
    try {
      const sensorsList = await registerPromise(
        apiRawFetch.listVirtualSensors(),
      );
      setVSensors(sensorsList);
      setIsLoading(false);
    } catch (err) {
      setError(err);
    } finally {
      setIsLoading(false);
    }
  }, [registerPromise]);

  React.useEffect(() => {
    if (enabled) {
      getVirtualLogCollectorList();
    }
  }, [enabled, getVirtualLogCollectorList]);

  return {
    error,
    isLoading,
    vSensors,
    getVirtualLogCollectorList,
  };
};
